export class DriveItem {
    description: string;
    id: string;
    name: string;

    constructor(init?: Partial<DriveItem>) {
        Object.assign(this, init);
    }

}
